import styled from 'styled-components';

import { Text as TextLayoutComponent, Header as HeaderLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  height: min-content;
  margin: 10px 0;
`;

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  word-wrap: break-word;
  margin-top: 15px;
  padding: 10px;
  overflow: auto;
`;

export const QuestionLabel = styled.span`
  ${({ marginBottom }) => marginBottom && 'margin-bottom: 15px;'};
  ${({ theme }) => theme && theme.text};
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 16px;
  user-select: text;
  font-weight: 500;
  padding-bottom: 15px;
  display: flex;
`;

export const Header = styled(HeaderLayoutComponent)`
  text-align: justify;
  margin-bottom: 0px;
  font-size: 24px;
`;

export const Label = styled(TextLayoutComponent)`
  font-size: 14px;
  color: #4D5473;
  text-align: justify;
  display: block;
  padding: 5px;
`;

export const Page = styled.div`
  height: min-content;
  margin: 5px 0;
  border-radius: 4px;
  border: 1px solid #ddd;
  padding: 5px;
  margin-bottom: 25px;
  background-color: #fff;
`;
